import { UserManager } from '../../business/manager/user';

export { default as DBManager } from './db';
export { StorageManager } from '../../business/storage/storage';

export const storageKey = {
  getCurrentChannelKey(gid: string): string {
    return `${gid}_current_channel`;
  },

  /**
   * 展示过任务完成弹窗
   */
  getSXTaskToastKey(): string {
    return `${UserManager.getInstance().getCurrentUid()}_task`;
  },

  /**
   * 设备id 随机生成一个，当做H5页面中的设备号
   */
  getDeviceIdKey(): string {
    return 'deviceId';
  },

  /**
   * 频道折叠本地配置存储
   */
  getChannelFoldDataKey(): string {
    return 'channel_fold_data';
  },
};
